
















import { TotalAssinantes } from "@/services/dashboard.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import Component from "vue-class-component";
import { Mixins, Prop } from "vue-property-decorator";
import { ticks, title } from "@/shared/utils/chart";

import ChartLine from "@/shared/components/chart-line.vue";

@Component({ components: { ChartLine } })
export default class GraficoTotalAssinantes extends Mixins(GlobalMixin) {
  //Configurações extras para o chartJs (Opcional)
  readonly options: Chart.ChartOptions | Chart.ChartLineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "index",
      callbacks: {
        //Configurar label do tooltip retornar o texto customizado
        //Com esta configuração deve retornar ex.: "Total: R$ 20,00"
        //Ao invés de: "Total: 20"
        title: title(),
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            callback: ticks(),
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            //Começar gráfico a partir do zero, sem valores negativos
            beginAtZero: true,
          },
        },
      ],
    },
  };

  @Prop({ default: false }) readonly loading!: boolean;
  @Prop() readonly value!: TotalAssinantes[];

  //computed
  get labels(): string[] | undefined {
    return this.value?.map((x) => x.data);
  }

  get dataSet(): Chart.ChartDataSets[] | undefined {
    return [
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Grátis",
        backgroundColor: "#cececea5",
        data: (this.value ?? []).map((x) => x.gratis ?? 0),
      },
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Lite",
        backgroundColor: "#007fffa5",
        data: (this.value ?? []).map((x) => x.lite ?? 0),
      },
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Essencial",
        backgroundColor: "#a52a2aa5",
        data: (this.value ?? []).map((x) => x.essencial ?? 0),
      },
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Essencial Conectada",
        backgroundColor: "#fc0339a5",
        data: (this.value ?? []).map((x) => x.essencialconectada ?? 0),
      },
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Super Conectada",
        backgroundColor: "#b503fca5",
        data: (this.value ?? []).map((x) => x.superconectada ?? 0),
      },
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Hiper Conectada",
        backgroundColor: "#bcf502a5",
        data: (this.value ?? []).map((x) => x.hiperconectada ?? 0),
      },
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Total Pago",
        backgroundColor: "#90ee90a5",
        data: (this.value ?? []).map((x) => x.totalpago ?? 0),
      },
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Total",
        backgroundColor: "#ffA500a5",
        data: (this.value ?? []).map((x) => x.total ?? 0),
      },
    ];
  }
}
